<template>
  <div class="s-leaseitnow-apply-form-response">
    <Alert type="success" class="mb-60">
      <p>
        {{ dictionary.applyResponseVehicleNamePrefix }}
        <strong>{{ carObj.name }}</strong>
        {{ dictionary.applyResponseVehicleNameSuffix }}
      </p>
      <p>{{ applyResponseText }}</p>
    </Alert>

    <div class="s-leaseitnow-apply-form-response__cta-buttons mb-30">
      <a
        v-if="offerPdf"
        :href="offerPdf"
        target="_blank"
        rel="noopener noreferrer"
        class="btn btn-primary"
        title="Προβολή Προσφοράς">
        {{ dictionary.buttonApplyResponseViewOfferText }}
      </a>

      <a
        v-if="detailsPdf"
        :href="detailsPdf"
        target="_blank"
        rel="noopener noreferrer"
        class="btn btn-primary"
        title="Προβολή Στοιχείων οχήματος">
        {{ dictionary.buttonApplyResponseViewDetailsText }}
      </a>
    </div>

    <div class="s-leaseitnow-apply-form-response__disclaimer">
      {{ dictionary.applyResponseDisclaimer }}
    </div>
  </div>
</template>

<script>
import Alert from './../../components/common/Alert.vue'
import mixinsLeaseItNow from './../../mixins/leaseitnow-mixins'

export default {
  components: { Alert },
  mixins: [mixinsLeaseItNow],
  props: {
    carObj: { required: true, type: Array },
    offerPdf: { required: false, type: String, default: '' },
    detailsPdf: { required: false, type: String, default: '' },
  },
}
</script>
